import { t } from '@/i18n'

import { formatCurrency } from '../fomatter.utils'
import { BODY_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { TaxRate } from '../types'

export class TaxesBreakdown implements TicketElement {
  taxRates: TaxRate[]
  taxLabel: string
  lineHeight: number
  separatorPadding: number
  topPadding: number

  constructor(taxRates: TaxRate[], taxLabel: string) {
    this.taxRates = taxRates
    this.taxLabel = taxLabel
    this.lineHeight = 22
    this.separatorPadding = 20
    this.topPadding = 10
  }

  height(): number {
    return (
      this.lineHeight * this.taxRates.length +
      this.lineHeight +
      this.topPadding +
      this.separatorPadding +
      this.lineHeight
    )
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.topPadding
    ctx.font = `12px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textAlign = 'right'
    ctx.fillText(t('report.total'), width, top)
    ctx.fillText(this.taxLabel, width * 0.75, top)
    ctx.fillText(t('report.subtotal'), width * 0.5, top)
    this.taxRates.forEach((taxRate: TaxRate) => {
      top += this.lineHeight
      ctx.textAlign = 'right'
      ctx.font = `bold 16px ${BODY_FONT}`
      ctx.fillText(formatCurrency(taxRate.total), width, top)
      ctx.font = `16px ${BODY_FONT}`
      ctx.fillText(formatCurrency(taxRate.tax), width * 0.75, top)
      ctx.fillText(formatCurrency(taxRate.taxableBase), width * 0.5, top)
      ctx.textAlign = 'left'
      ctx.fillText(`${this.taxLabel} (${taxRate.taxPercentage}%):`, 0, top)
    })

    const totalTax = this.taxRates.reduce((sum, taxRate) => sum + taxRate.tax, 0)
    top += this.separatorPadding
    ctx.fillRect(0, top, width, 1)
    top += this.lineHeight
    ctx.font = `bold 12px ${BODY_FONT}`
    ctx.textAlign = 'left'
    ctx.fillText(t('z-report.total-vat') + ':', 0, top)
    ctx.textAlign = 'right'
    ctx.fillText(formatCurrency(totalTax), width * 0.75, top)
  }
}
